import { Table, Box } from '@mantine/core';

import { columns } from '../../../constants';
import { analyticsTypes } from '../../../types';

import { TableBody } from './TableBody';
import { TableHeader } from './TableHeader';

type Props = {
  rows: analyticsTypes.RequestsTableRow[];
};

export const StatsTable = ({ rows }: Props) => {
  return (
    <Box>
      <Table stickyHeader striped highlightOnHover>
        <TableHeader columns={columns} />
        <TableBody rows={rows} columns={columns} />
      </Table>
    </Box>
  );
};
